<template>
        <widget :title="title" :router="router">
            <el-date-picker
                v-model="queryDate"
                type="date"
                placeholder="选择日期"
                @change="query"
                style="width:200px;position: absolute;top:15px;right:50px;" size="mini">
            </el-date-picker>
            <div class="widget_cont" ref="chart_ele" v-if="lineDate && lineDate.length > 0" :key="re"></div>
            <div class="null" v-if="!lineDate || lineDate.length == 0"><img src="../img/zj_widget/null.png"></div>
        </widget>
    </template>
    <script>
        import widget from './zj_warp'
        import selectCom from './select'
        import widgetFilter from './widgetFilter.js'
        export default {
            components: {
                widget,
                selectCom
            },
            props:{
                title:{
                    type:String
                },
                swWidth:{
                    type:Number,
                    default:1
                },
                item:{
                    type:Object
                }
            },
            filters:{
                format:function(val){
                    return '.'+val.split('.')[1]
                }
            },
            data(){
                return {
                    widgetType:1,
                    router:'evaluation_radio_list',
                    configList:null,
                    queryDate:1539575888000,
                    widgetUrl:'',
                    lineDate:[],
                    teacherId:window.appframe.$store.state.userInfo.id,
                    re:1,
                }
            },
            mounted(){
                let vm = this
                vm.$nextTick(function(){
                    vm.widgetType = _.cloneDeep(vm.swWidth)
                    if(vm.item.configList.length > 0){
                        let configList = vm.item.configList
                        vm.configList = widgetFilter.getFieldMap(configList)
                        let stemp = []
                        for(let i in vm.configList){
                            stemp.push(vm.configList[i])
                        }
                        vm.widgetUrl = stemp[0].apiUrl
                        vm.query()
                    }
                })
            },
            methods: {
                query(){
                    let vm = this
                    let queryDate = new Date(this.queryDate).getTime()
                    http.get('/gateway/evaluation-manage/evaluation/recode/evalInfo?teacherId='+vm.teacherId+'&queryDate='+queryDate).then(function(xhr){
                        let objectA = xhr.data.data
                        vm.lineDate = objectA
                        if(objectA && objectA.length>0){
                            let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                            var newObj = new Object();
                            let lineDate = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                            
                            let xAxis = []
                            let series = []
                            _.each(lineDate,function(v){
                                xAxis.push(v.itemName)
                                series.push(v.detailScore)
                            })
                            vm.$nextTick(function(){
                                let myChart = echarts.init(vm.$refs["chart_ele"]) 
                                let title = lineDate[0].activityName + ':' + lineDate[0].totalScore + '分'
                                let option = {
                                        color: ['#4CB7FE', '#FFC271', '#60E6CA'],
                                        title:{
                                            text:title,
                                            x:'center',
                                            textStyle:{
                                                fontSize:12,
                                                color:'#333'
                                            }
                                        },
                                        color:['#62e6ca'],
                                        tooltip: {
                                            trigger: 'axis'
                                        },
                                        grid: {
                                            top:'40px',
                                            left: '3%',
                                            right: '30px',
                                            bottom: '3%',
                                            containLabel: true
                                        },
                                        xAxis: {
                                            type: 'category',
                                            boundaryGap: false,
                                            data: xAxis,
                                            axisLine: {
                                                lineStyle: {
                                                color: '#007bc6',
                                                width:2
                                                }
                                            },
                                            splitLine: {
                                                show: true,
                                                lineStyle: {
                                                color: '#e9eaea'
                                                }
                                            },
                                            axisTick: {
                                                show: false
                                            },
                                        },
                                        yAxis: {
                                            type: 'value',
                                            name:'（分数）',
                                            nameTextStyle:{
                                                color:'#4183fc'
                                            },
                                            axisTick: {
                                                show: false
                                            },
                                            axisLine: {
                                                lineStyle: {
                                                color: '#007bc6',
                                                width:2
                                                }
                                            },
                                            splitLine: {
                                                show: true,
                                                lineStyle: {
                                                color: '#e9eaea'
                                                }
                                            },
                                            axisLabel: {
                                                margin: 10,
                                                textStyle: {
                                                fontSize: 12,
                                                color:'#333'
                                                }
                                            },
                                        },
                                        series: [
                                            {
                                                type:'line',
                                                smooth:true,
                                                symbol: 'circle',
                                                symbolSize: '8',
                                                data:series
                                            }
                                        ]
                                    };
                                myChart.setOption(option);
                            })
                        }
                    })
                }
            }
        }
    </script>
    <style scoped lang="less">
        .widget_cont{
            height: 260px;
            margin: 10px;
        }
        .null{
            text-align: center;
            line-height: 270px;
            img{
                vertical-align:middle;
            }
        }
    </style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_evaluation_info.vue